(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('biomee-slider')) {
    customElements.define(
      'biomee-slider',
      class BiomeeSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.index = 0;
          this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.track || this.slides.length < 2) return;

          this.abort = new AbortController();
          const { signal } = this.abort;

          this.dots.forEach((dot, i) =>
            dot.addEventListener('click', () => {
              this.goTo(i);
              this.start();
            }, { signal })
          );
          this.track.addEventListener('scroll', () => this.onScroll(), { signal, passive: true });
          this.addEventListener('mouseenter', () => this.stop(), { signal });
          this.addEventListener('mouseleave', () => this.start(), { signal });
          this.addEventListener('focusin', () => this.stop(), { signal });
          this.addEventListener('focusout', () => this.start(), { signal });
          this.track.addEventListener('touchstart', () => this.stop(), { signal, passive: true });
          this.track.addEventListener('touchend', () => this.start(), { signal, passive: true });
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()), { signal });

          // Theme editor: show the slide being edited and hold it there.
          document.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i === -1) return;
            this.stop();
            this.goTo(i);
          }, { signal });
          document.addEventListener('shopify:block:deselect', (event) => {
            if (this.slides.includes(event.target)) this.start();
          }, { signal });

          this.start();
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.stop();
        }

        start() {
          this.stop();
          if (this.reduceMotion || this.slides.length < 2) return;
          this.timer = setInterval(() => this.goTo((this.index + 1) % this.slides.length), this.delay);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }

        goTo(i) {
          this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.reduceMotion ? 'auto' : 'smooth' });
          this.setActive(i);
        }

        onScroll() {
          const i = Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth);
          if (i !== this.index && this.slides[i]) this.setActive(i);
        }

        setActive(i) {
          this.index = i;
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
